import { CSSVariablesResolver, MantineThemeOverride } from '@mantine/core'
import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'src/v2/store/hooks'

import { selectUICurrentTheme } from '../selectors/ui.selectors'
import { setCurrentTheme } from '../store/ui.store'
import { ThemeType } from '../ui.types'
import {
  applyCustomCssVariables,
  applyThemeAttribute,
  createMantineTheme,
  themeConfigs,
} from '../utils/theme.utils'

export const useTheme = () => {
  const dispatch = useAppDispatch()
  const currentTheme = useAppSelector(selectUICurrentTheme)

  const loadTheme = useCallback(
    (themeName: ThemeType) => {
      dispatch(setCurrentTheme(themeName))

      applyThemeAttribute(themeName)

      if (themeConfigs[themeName]) {
        applyCustomCssVariables(themeConfigs[themeName])
      }

      return createMantineTheme(themeName)
    },
    [dispatch],
  )

  const getMantineThemeConfig = useCallback((): {
    theme: MantineThemeOverride
    cssVariablesResolver: CSSVariablesResolver
  } => {
    const themeType = currentTheme || ThemeType.IDG

    if (themeConfigs[themeType]) {
      applyCustomCssVariables(themeConfigs[themeType])
    }

    return createMantineTheme(themeType)
  }, [currentTheme])

  return {
    currentTheme,
    loadTheme,
    getMantineThemeConfig,
  }
}
